import { ScheduleTaskAttributeRateKeyBase } from './base/schedule-task-attribute-rate-key-base';

export class ScheduleTaskAttributeRateKey extends ScheduleTaskAttributeRateKeyBase { }